import { useQuery } from 'react-query'
import API from '.'

const ENDPOINT = '/api/tyres'

export const useGetTyreModels = (params, config = {}) =>
  useQuery(
    ['tyreModels', 'list', params],
    async () =>
      (await API.get(`${ENDPOINT}/models?${new URLSearchParams(params).toString()}`)).data,
    config
  )

export const useGetTyreSizes = (params, config = {}) =>
  useQuery(
    ['tyreSizes', 'list', params],
    async () => (await API.get(`${ENDPOINT}/sizes?${new URLSearchParams(params).toString()}`)).data,
    config
  )

export const useGetTyreLocalNumbers = (params, config = {}) =>
  useQuery(
    ['tyreLocalNums', 'list', params],
    async () =>
      (await API.get(`${ENDPOINT}/locals?${new URLSearchParams(params).toString()}`)).data,
    config
  )

export const useGetTyreByLocalNumber = (localNum, params, config = {}) =>
  useQuery(
    ['tyre', 'detail', localNum],
    async () =>
      localNum
        ? (
            await API.get(
              `${ENDPOINT}/locals/${localNum}?${new URLSearchParams(params).toString()}`
            )
          ).data
        : null,
    config
  )
